import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  NgModule,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AuthSevices } from 'libs/api/src/lib/auth.service';
import { observable, Observable } from 'rxjs';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
// import { FactoryHttpLoader } from '../../helpsupport/helpsupport.component';

import { PaymentStatusTimelineComponent } from '@fitness-force/billing';
import { PaymentSummaryComponent } from '../payment-summary/payment-summary.component';
import { InvoiceClient } from '@fitness-force/models';

@Component({
  selector: 'payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    PaymentStatusTimelineComponent,
    PaymentSummaryComponent,
    TranslateModule,
  ],
})
export class PaymentComponent implements OnInit {
  @Input('showPayment') showPayment = false;
  @Input('invoiceDetailById') getInvoiceById$: Observable<InvoiceClient>;

  @Output() closeSidePopupMember: EventEmitter<{
    hideSidebar: boolean;
    uuid: string | null;
  }> = new EventEmitter();
  @Output() GoToClientSubscription: EventEmitter<boolean> = new EventEmitter();

  @Output() hidePaymentSidebar: EventEmitter<boolean> = new EventEmitter();

  showPaymentStatusTimeLine = false;

  uuid: string;
  ispayment = false;
  currentUserDetails: any;

  constructor(private authService: AuthSevices) {}

  ngOnInit(): void {
    this.currentUserDetails = this.authService.decodedToken;
  }

  ClosePaymentSummary(evt: any) {
    if (evt.clientSignupUUID) {
      this.ispayment = true;
      this.showPayment = false;
      this.uuid = evt.clientSignupUUID;
      this.showPaymentStatusTimeLine = true;
    } else {
      this.showPayment = false;
      this.GoToClientDetails();
    }
  }

  GoToClientDetails() {
    this.showPayment = false;
    this.showPaymentStatusTimeLine = false;
    this.hidePaymentSidebar.emit(false);
  }
}
